import useTrackerBasicInfo from 'hooks/useTrackerBasicInfo';
import { Topic } from 'models/topic';
import { TopicEventParams } from 'utils/firebase/topicTracker';

interface UseTopicEventParamsProps {
  topic: Topic;
}

const useTopicEventParams = ({
  topic,
}: UseTopicEventParamsProps): TopicEventParams => {
  const trackerBasicInfo = useTrackerBasicInfo();

  return {
    ...trackerBasicInfo,
    course_id: topic?.course_id ?? '',
    unit_id: topic?.bundle_id ?? '',
    topic_id: topic?.id ?? '',
  };
};

export default useTopicEventParams;
